module.exports = __webpack_public_path__ + "static/media/NICE_Step2a_Image2h.bc50a5df.jpg";